const history = {
  table: {
    headers: {
      createdBy: 'Por',
      createdAt: 'Criado em',
      updatedAt: 'Última atualização',
      updatedBy: 'Por',
      oldValue: 'Valor antigo',
      newValue: 'Novo Valor',
      date: 'Data',
      beforeCopy: {
        regular: 'Copiar',
        sessionId: 'Copiar ID da Seção',
      },
      afterCopy: 'Copiado',
    },
  },
};

export default history;
